/* src/app/common/components/menus/menus.component.scss */
.toolbar-container ion-toolbar {
  --background: transparent;
  --min-height: auto;
}
.toolbar-container ion-toolbar ion-title {
  padding: 0;
  font-size: 28px;
  font-weight: 500;
}
.toolbar-container ion-toolbar .actions {
  margin-right: -0.5rem;
}
.toolbar-container ion-toolbar .actions > ion-button,
.toolbar-container ion-toolbar .actions > app-button-group {
  margin: 0 0.5rem;
}
:host {
  display: block;
}
section.menus-container.row {
  --bs-gutter-x: 0;
  --bs-gutter-y: 0;
  padding: 0.5rem;
}
section.menus-container.row > .col {
  padding: 1rem;
}
ion-card {
  margin: 0;
  border-radius: var(--card-border-radius, 0);
  box-shadow: none;
  border: 1px solid transparent;
  box-sizing: border-box;
  transition: border-color 0.1s ease-in-out 0.25s;
  cursor: pointer;
  min-width: 200px;
}
ion-card:focus-within,
ion-card:hover {
  border-color: rgba(0, 0, 0, 0.13);
}
ion-card:focus-within ion-card-header .actions,
ion-card:hover ion-card-header .actions {
  opacity: 1;
}
ion-card .thumbnail {
  height: 100px;
  max-height: 100px;
  overflow: hidden;
  background-image: url(https://ionicframework.com/docs/demos/api/thumbnail/thumbnail.svg);
  background-repeat: no-repeat;
  background-position: center center;
  -webkit-background-size: cover;
  background-size: cover;
  position: relative;
}
ion-card .thumbnail .indicators {
  position: absolute;
  right: 0.125rem;
  top: 0.125rem;
}
ion-card .thumbnail .indicators > * {
  margin: 0.125rem;
  padding: 0.125rem;
  background-color: #fff;
  border-radius: 50%;
}
ion-card .thumbnail .indicators ion-icon {
  font-size: 20px;
}
ion-card ion-card-header {
  padding: 0;
  align-items: start;
}
ion-card ion-card-header .title-container {
  margin-bottom: -18px;
}
ion-card ion-card-header ion-card-title {
  max-width: 160px;
  font-size: 1rem !important;
  font-weight: 600;
}
ion-card ion-card-header ion-card-subtitle {
  margin-top: 4px;
}
ion-card ion-card-header ion-card-subtitle > * {
  display: inline-block;
  vertical-align: middle;
  padding: 0 2px;
}
ion-card ion-card-header ion-card-subtitle ion-icon {
  vertical-align: middle;
}
ion-card ion-card-header ion-card-subtitle.tags ion-icon {
  vertical-align: text-bottom;
}
ion-card ion-card-header section.actions {
  position: absolute;
  top: -8px;
  right: 0;
  opacity: 0;
}
ion-card ion-card-header section.actions ion-button {
  margin: 0;
}
ion-card ion-card-header section.actions ion-button ion-icon {
  font-size: 20px;
}
ion-card ion-card-content {
  padding: 1rem 0 0;
}
.child-count {
  color: var(--ion-color-dark);
  font-weight: bolder;
}
.my-custom-modal-css .modal-wrapper {
  height: 20%;
  top: 80%;
  position: absolute;
  display: block;
}
/*# sourceMappingURL=menus.component.css.map */
